import * as moment from 'moment';
import { TipoDocumento } from './tipoDocumento';
import { Provincia } from './provincia';
import { Pais } from './pais';

export class Pasajeros {
	id: number;
	tipoDocumento: TipoDocumento;
	numeroDocumento: string;
	descripcionDocumento: string;
	nombre: string;
	apellido: string;
	sexo: string;
	vtoLicencia: any;
	menor: boolean;
	origen: string;
	provinciaOrigen: Provincia;
	destino: string;
	provinciaDestino: Provincia;
	nacionalidad: Pais;
	viajeCancelado: boolean;
	nroButaca: string;
	ocupaButaca: boolean;
	tripulante: boolean;
	new: boolean;

	constructor(data = null) {
		if (data) {
			this.id = data.id;
			this.tipoDocumento = new TipoDocumento(data.tipoDocumento);
			this.numeroDocumento = data.numeroDocumento;
			this.nombre = data.nombre;
			this.apellido = data.apellido;
			this.sexo = data.sexo;
			this.vtoLicencia = data.vtoLicencia;
			this.menor = data.menor ? data.menor : false;
			this.origen = data.origen;
			this.provinciaOrigen = new Provincia(data.provinciaOrigen);
			this.destino = data.destino;
			this.provinciaDestino = new Provincia(data.provinciaDestino);
			this.nacionalidad = data.nacionalidad ? new Pais(data.nacionalidad) : null;
			this.viajeCancelado = data.viajeCancelado ? data.viajeCancelado : false;
			this.nroButaca = data.nroButaca;
			this.ocupaButaca = data.ocupaButaca;
			this.tripulante = data.tripulante ? data.tripulante : false;
			this.descripcionDocumento = data.descripcionDocumento;
			this.new = data.new ? data.new : false;
		}
	}
}
